import React from "react";
import { ButtonVariants } from "@certa/catalyst/components/Button";
import { Filter } from "@certa/icons/components/Filter";
import { AddFilterButton } from "@certa/dashboards/src/components/workflowFilters/AdvancedFilter/AddFilterButton";

type ObjectFilterButtonProps = {
  noOfRules: number;
  disabled?: boolean;
  onClick?: () => void;
};

export const ObjectFilterButton: React.FC<ObjectFilterButtonProps> = ({
  noOfRules,
  disabled = false,
  onClick
}) => {
  const hasRules = noOfRules > 0;

  return (
    <AddFilterButton
      variant={hasRules ? ButtonVariants.FILLED : ButtonVariants.OUTLINE}
      leftIcon={<Filter size={16} />}
      disabled={disabled}
      onClick={onClick}
      noOfRules={noOfRules}
    />
  );
};
